import { useController } from 'react-hook-form';
import { FieldProps } from 'lib/iterable-hook-form/FormField/types';
import { FrequencyMode } from 'modules/frequencyManagement/lib/types';
import { useFocusContext } from 'modules/frequencyManagement/contexts/FocusContext';
import { BasicSelect, BasicSelectProps, SelectValueType } from 'ui/selects';

type BasicSelectFieldProps<TValue extends SelectValueType = string> = FieldProps<TValue> &
  Omit<BasicSelectProps<TValue>, 'defaultValues' | 'isError' | 'onSelect'> & {
    rootName: string | undefined;
  };

/**
 * This BasicSelectFieldWithFocusHook component is a copy of the BasicSelectField in
 * lib/iterable-hook-form, except that adds custom logic to set focusId on selection.
 */
export const BasicSelectFieldWithFocusHook = <TValue extends SelectValueType = string>({
  name,
  defaultValue,
  rootName,
  ...rest
}: BasicSelectFieldProps<TValue>) => {
  const { setFocusIdForRootName } = useFocusContext();
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <BasicSelect
      {...rest}
      isError={!!error}
      defaultValues={[value]}
      onSelect={([selectedValue]) => {
        onChange(selectedValue);
        setFocusIdForRootName(selectedValue as FrequencyMode, rootName);
      }}
    />
  );
};
